import { Route, Routes, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { Home } from "@pages/public/Home";
import PublicRoute from "./PublicRoute";
import { Tracking } from "@pages/public/Tracking";
import { Auth } from "@pages/public/Auth";
import { Dashboard } from "@pages/auth/Dashboard";
import { ChangePassword } from "@pages/auth/ChangePassword";
import { FAQ } from "@pages/public/FAQ";
import { Management } from "@pages/auth/Management";
import { OrderTrackingsManagement } from "@pages/auth/trackings/OrderTrackingsManagement";
import ManagementRoute from "./ManagementRoute";
import { UserManagementDashboard } from "@pages/auth/users/UserManagementDashboard";
import { UserManagementList } from "@pages/auth/users/UserManagementList";
import { UserAccessMapping } from "@pages/auth/users/UserAccessMapping";
import { WebhookRecords } from "@pages/auth/webhooks/WebhookRecords";

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes with PublicRoute wrapper */}
      <Route element={<PublicRoute />}>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Home />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/tracking/:code" element={<Tracking />} />
      </Route>

      {/* Protected Routes with ProtectedRoute wrapper */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/password/change" element={<ChangePassword />} />

        {/* Management */}
        <Route element={<ManagementRoute />}>
          <Route path="/management" element={<Management />} />
          <Route
            path="/management/trackings"
            element={<OrderTrackingsManagement />}
          />
          <Route
            path="/management/users"
            element={<UserManagementDashboard />}
          />
          <Route
            path="/management/users/list"
            element={<UserManagementList />}
          />
          <Route
            path="/management/users/access-map"
            element={<UserAccessMapping />}
          />
          <Route path="/management/webhooks" element={<WebhookRecords />} />
        </Route>
      </Route>

      {/* Fallback - redirect any not identified routes */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
